import React from 'react';
import './ListElement.css';
import TypeTag from '../tags/TypeTag.js';

const SettingsGridElement = ({ test, isEnabled, onToggle }) => {
    return (
        <div className="list-element" style={{
            backgroundColor: '#f5f5f5',
            padding: '1rem',
            borderRadius: '4px',
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '0.5rem'
            }}>
                <TypeTag reportType={test.test_type} isButton={false} />
                <button
                    onClick={() => onToggle(test.test_metadata_id)}
                    style={{
                        padding: '0.25rem 0.5rem',
                        backgroundColor: isEnabled ? '#28a745' : '#dc3545',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '0.8rem',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.25rem',
                        height: '24px'
                    }}
                >
                    <i className={`fas ${isEnabled ? 'fa-check' : 'fa-times'}`}></i>
                    <span>{isEnabled ? 'Enabled' : 'Disabled'}</span>
                </button>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                    <div style={{ fontWeight: 'bold' }}>
                        <span style={{ color: '#666', marginRight: '0.5rem' }}>#{test.test_metadata_id}</span>
                        {test.test_name}
                    </div>
                    <div style={{ color: '#666', fontSize: '0.9rem' }}>{test.issue_message}</div>
                </div>
            </div>
        </div>
    );
};

export default SettingsGridElement; 